import * as React from 'react';
import Slide from '@mui/material/Slide';

const ModalTransitionComponent: React.ComponentType<{
	children?: React.ReactElement<any, any>;
}> = React.forwardRef((props, ref) => (
	<Slide ref={ref} {...props} direction="up" children={props.children as React.ReactElement<any, any>} />
));

export default ModalTransitionComponent;
